import * as api from '../../api';
import * as modifyMessageUtilities from './modify-message-utilities';
import { dateUtilities, errorUtilities } from '../../common';
import moment from 'moment';

export const fetchActions = api.fetchActions('modify-message', 'fetch-message');
export const addMessageActions = api.fetchActions('modify-message', 'add-message');
export const updateMessageActions = api.fetchActions('modify-message', 'update-message');

export const actionTypes = {
  ...fetchActions.actionTypes,
  ...addMessageActions.actionTypes,
  ...updateMessageActions.actionTypes,
  UPDATE_VALUE : 'modify-message.update-value',
  UPDATE_VALIDATION : 'modify-message.update-validation',
  SHOW_ADD_VALIDATION : 'modify-message.show-add-validation',
  SHOW_EDIT_VALIDATION : 'modify-message.show-edit-validation',
  SHOW_DATE_RANGE_CONFIRM_MODAL : 'modify-message.show-date-range-confirm-modal',
  CLOSE_DATE_RANGE_CONFIRM_MODAL : 'modify-message.close-date-range-confirm-modal'
}

export const fetchMessage =(id) => api.shouldExecute(['modifyMessage', 'dashboardMessages', id],
  api.getThunk(`/dashboard-messages/${id}`, {}, fetchActions, {id}));

export function addMessage() {
  return (dispatch, getState) => {
    const state = getState();
    const { modifyMessage } = state;
    const { newValue } = modifyMessage;
    return dispatch(api.postThunk(`/dashboard-messages`, newValue, addMessageActions));
  }
}

export function updateMessage(id) {
  return (dispatch, getState) => {
    const state = getState();
    const { modifyMessage } = state;
    const { dashboardMessages, editValues } = modifyMessage;
    const value = editValues && editValues.get(id);
    const rawOldData = dashboardMessages && dashboardMessages.getIn([id, 'data']);
    var defaultValues = modifyMessageUtilities.convertMessageToUiFormat(rawOldData);
    const mergedValue = modifyMessageUtilities.mergeData(value, defaultValues);
    return dispatch(api.putThunk(`/dashboard-messages/${id}`, mergedValue, updateMessageActions, { id }));
  }
}

export function updateValue(path, value) {
  return {
    type : actionTypes.UPDATE_VALUE,
    path,
    value
  }
}

export function validateForm(newDataPath, oldDataPath, validationPath) {
  return (dispatch, getState) => {
    const state = getState();
    const { modifyMessage } = state;
    var newData = newDataPath && modifyMessage.getIn(newDataPath);
    var rawOldData = oldDataPath && modifyMessage.getIn(oldDataPath);
    var oldData = modifyMessageUtilities.convertMessageToUiFormat(rawOldData);
    const mergedData = modifyMessageUtilities.mergeData(newData, oldData);
    var errors = [];

    var startDateRestriction = rawOldData ? rawOldData.createdAtUtc : moment().format('MM/DD/YYYY');
    // check if content has a value
    if(!mergedData.content) {
      errors.push(errorUtilities.validationError('content', 'invalid-content', 'modify-message', errors.length, "the message content is required", errorUtilities.errorTypes.inline));
    }

    // check if valid date string
    if(mergedData.useDateRange) {
      if(mergedData.publishStartDate) {
        if(!dateUtilities.isValidDate(mergedData.publishStartDate)) {
          errors.push(dateUtilities.invalidDateError('start', 'invalid-start', 'modify-message', errors.length));
        }
        else {
          startDateRestriction = mergedData.publishStartDate;
        }
      }
      if(mergedData.publishEndDate) {
        if(!dateUtilities.isValidDate(mergedData.publishEndDate)) {
          errors.push(dateUtilities.invalidDateError('end', 'invalid-end', 'modify-message', errors.length));
        }
        else {
          // check date limits
          if(startDateRestriction && !dateUtilities.isAfterDate(mergedData.publishEndDate, startDateRestriction)) {
            var message = "End date must be after the start date.";
            errors.push(errorUtilities.validationError('end', 'invalid-end', 'modify-message', errors.length, message, errorUtilities.errorTypes.inline));
          }
        }
      }

    }

    return dispatch(setValidationResult(validationPath, errors));
  }
}

function setValidationResult(path, value) {
  return {
    type : actionTypes.UPDATE_VALIDATION,
    path,
    value
  }
}

export function showAddValidation() {
  return {
    type : actionTypes.SHOW_ADD_VALIDATION
  }
}

export function showEditValidation(id) {
  return {
    type : actionTypes.SHOW_EDIT_VALIDATION,
    id
  }
}

export function showDateRangeConfirmModal() {
  return {
    type : actionTypes.SHOW_DATE_RANGE_CONFIRM_MODAL,
  }
}

export function closeDateRangeConfirmModal() {
  return {
    type : actionTypes.CLOSE_DATE_RANGE_CONFIRM_MODAL,
  }
}
